<!--suppress ALL -->
<template>
	<v-select
		:items="options"
		:loading="loading"
		:small-chips="multiple" :multiple="multiple" v-model="model" label="בחר ארגונים" item-text="name"
		item-value="id"></v-select>
</template>

<script>
	import OrganizationModule from "src/store/modules/Organization.module";

	export default {
		name: "organizations-select",
		props: {value: {default: null}, multiple: Boolean},
		data() {
			return {
				loading: false
			};
		},
		components: {},
		computed: {
			options() {
				return this.$store.state.OrganizationModule.organizations;
			},
			model: {
				get() {
					return this.value;
				},
				set(val) {
					return this.$emit("input", val);
				}
			}
		},
		// mixins: [new SelectMixin(OrganizationModule, "organizations")],
		async created() {
			this.loading = true;
			await this.$store.dispatch(OrganizationModule.types.FETCH);
			this.loading = false;
		}
	};
</script>
